export default function setFlagClass( element, prefix, value ) {
	let classNames = element.classList;
	// If forEach isn't supported, recreat from className string
	if ( typeof classNames.forEach === 'undefined' ) {
		classNames = element.classList.split( ' ' );
	}

	classNames.forEach( className => {
		if ( className.indexOf( prefix ) === 0 ) {
			element.classList.remove( className );
		}
	} );

	if ( value ) {
		element.classList.add( `${ prefix }-${ value }` );
	}
}
